import { gql } from 'graphql-request';

export const SEND_TO_GARMIN = gql`
  query SendToGarmin($klass: String!, $id: ID!) {
    sendToGarmin(klass: $klass, id: $id)
  }
`;
